import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[(_vm.serveStatus === 'live')?[_c('beach-club-live',{attrs:{"url_id":_vm.geturlDomain,"outlet_id":''}})]:[_c('beach-club',{attrs:{"url_id":_vm.geturlDomain,"outlet_id":''}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }